function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_1899",
  "data-name": "Rectangle 1899",
  width: 19,
  height: 20,
  transform: "translate(-0.325 -0.247)",
  fill: "#d6d6d6",
  stroke: "#707070",
  strokeWidth: 1.5
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "half-won-icon",
  transform: "translate(0.75 0.246)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1125",
  "data-name": "Path 1125",
  d: "M110.1,60.594l-7.575-7.575.672-.672,6.867,6.867,11.693-13.222.706.636Z",
  transform: "translate(-102.524 -43.5)",
  fill: "none",
  stroke: "#4b9633",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_202",
  "data-name": "Mask Group 202",
  transform: "translate(8.723 0)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1124",
  "data-name": "Path 1124",
  d: "M110.1,60.594l-7.575-7.575.672-.672,6.867,6.867,11.693-13.222.706.636Z",
  transform: "translate(-111.247 -43.5)",
  fill: "none",
  stroke: "#d6d6d6",
  strokeWidth: 1.5
})));

function SvgHalfWonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.148,
    height: 20,
    viewBox: "0 0 28.148 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfWonIcon);
export default __webpack_public_path__ + "static/media/half-won-icon.c4c88008.svg";
export { ForwardRef as ReactComponent };